import { getRelationLabelByTypeAndPersonType } from '@dealstack/frontend/app/pages/Project/Cap/CapEntityManageFlow/tabs/BasicDetails/components/EditRelatedPersonDrawer/utils/relatedPeopleLabel.ts';
import { I18Namespaces } from '@dealstack/shared/lib/common/i18n/i18n.ts';
import { PersonRelationType, PersonType } from '@dealstack/shared/lib/generated';
import { TranslateFunction } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.types';

// Explicit list rather than every enum value, so a future enum addition can't
// surface here unlabelled before its deal-directory copy and sections exist.
const RELATION_TYPES: PersonRelationType[] = [
	PersonRelationType.PIV,
	PersonRelationType.REPRESENTATIVE,
	PersonRelationType.UBO,
	PersonRelationType.PSC,
	PersonRelationType.DIRECTOR,
	PersonRelationType.TRUSTEE,
	PersonRelationType.SETTLER_OR_GRANTOR,
	PersonRelationType.PROTECTOR_OR_ENFORCER,
	PersonRelationType.BENEFICIARY,
	PersonRelationType.OTHER,
];

export const makeRelationTypeOptions = (
	tCapManage: TranslateFunction<I18Namespaces.CAP_MANAGE>,
	selectedEntityType?: PersonType
) =>
	RELATION_TYPES.map((type) => ({
		label: getRelationLabelByTypeAndPersonType(tCapManage, type, selectedEntityType),
		value: type,
	}));
